module.exports = __webpack_public_path__ + "img/高江優介.014e4589.jpg";